import { Stack } from "@mui/material";
import ReorderTabs from "./tabs";

const Reorder = () => {
  return (
    <Stack maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <ReorderTabs />
    </Stack>
  );
};

export default Reorder;
